<template>
  <Layout header-class="header-left-align" nav-alignment="left">
    <BlogBanner :title="archiveTitle" :lead="summary" :breadcrumb="breadcrumb" archive />
    <div class="rn-blog-area rn-section-gap">
      <div class="container">
        <div class="blog-archive__toolbar">
          <router-link to="/Blog">{{ $t('Blog.back_to_blog') }}</router-link>
        </div>
        <div v-if="archivePosts.length" class="row row--15">
          <div
            v-for="(blog, index) in archivePosts"
            :key="blog.id"
            class="col-lg-4 col-md-6 col-12 mt--30"
            data-aos="fade-up"
            :data-aos-delay="index * 100"
          >
            <BlogPost :blog="blog" />
          </div>
        </div>
        <p v-else class="blog-archive__empty" role="status">
          {{ $t('Blog.archive_empty') }}
        </p>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../common/Layout'
import BlogBanner from './BlogBanner'
import BlogPost from './BlogPost'
import BlogPostMixin from '../../mixins/BlogPostMixin'
import AppFunctions from '../../helpers/AppFunctions'

export default {
  name: 'BlogArchive',
  components: { Layout, BlogBanner, BlogPost },
  mixins: [BlogPostMixin],
  props: {
    kind: {
      type: String,
      required: true,
      validator: (value) => ['category', 'tag'].includes(value)
    }
  },
  computed: {
    slug() {
      return this.$route.params.slug
    },
    isAll() {
      return this.kind === 'category' && this.slug === 'all'
    },
    taxonomy() {
      return this.kind === 'category' ? 'categories' : 'tags'
    },
    term() {
      for (const post of this.posts) {
        const match = post[this.taxonomy].find((term) => AppFunctions.slugify(term) === this.slug)
        if (match) return match
      }
      return ''
    },
    archiveTitle() {
      if (this.isAll) return this.$t('Blog.all_articles')
      if (this.term) return this.$t(`Blog.${this.taxonomy}.${this.term}`)
      return this.$t('Blog.archive_not_found')
    },
    archivePosts() {
      if (this.isAll) return this.posts
      return this.posts.filter((post) => post[this.taxonomy].includes(this.term))
    },
    breadcrumb() {
      if (this.isAll || !this.term) return this.archiveTitle
      return this.$t(`Blog.${this.kind}_label`, { name: this.archiveTitle })
    },
    summary() {
      return this.$tc('Blog.article_count', this.archivePosts.length, {
        count: this.archivePosts.length
      })
    }
  }
}
</script>
